import { IDiscoverRedesignPhase3XP } from "@faire/web-api/com/faire/search/IDiscoverRedesignPhase3XP";
import { ENABLE_VERTICALIZED_BANNER_ON_DISCOVER_PAGE_240819 } from "@faire/web-api/indigofair/settings/ENABLE_VERTICALIZED_BANNER_ON_DISCOVER_PAGE_240819";

import { useAssignSetting, useSetting } from "./__internal__/useSetting";

export const useSettingDiscoverRedesignPhase3XP =
  (): IDiscoverRedesignPhase3XP =>
    useSetting(
      ENABLE_VERTICALIZED_BANNER_ON_DISCOVER_PAGE_240819,
      IDiscoverRedesignPhase3XP.Bucket.CONTROL
    );

export const useAssignSettingDiscoverRedesignPhase3XP = () =>
  useAssignSetting(ENABLE_VERTICALIZED_BANNER_ON_DISCOVER_PAGE_240819);
